import { required, optional, array, obj } from 'AppReact/schema';
import { extendedItem } from './item';

export default {
  cancellation: obj({
    date: optional('jsDate'),
    name: optional('string'),
    reason: optional('string')
  }),
  assigned_to: optional('string'),
  completed_by: optional('string'),
  created_by: required('string'),
  creation_date: required('jsDate'),
  completion_date: optional('jsDate'),
  due_date: optional('jsDate'),
  id: required('integer'),
  items: array(obj(extendedItem)),
  has_charges: required('boolean'),
  total_cost_in_cents: optional('integer'),
  property_name: required('string'),
  status: required('string'),
  template_name: required('string'),
  template_id: required('integer'),
  icon: optional('string'),
  can_assign_admin: required('boolean'),
  can_assign_tech: required('boolean'),
  can_assign_resident: required('boolean'),
  unit: optional('string'),
  due_date: optional('jsDate'),
  document_export_error: optional('string'),
  document_exported_on: optional('jsDate'),
  applicant_id: optional('integer')
};
